import { API } from 'aws-amplify'

import { CategoryDto, CreateSubCategoryDto, SubCategoryDto } from 'types'

export const getSubCategory = async (categoryId: string, subCategoryId: string): Promise<CategoryDto[]> => {
    return API.get('api', `/category/${categoryId}/subcategories/${subCategoryId}`, {})
}

export const getMySubCategories = async (): Promise<SubCategoryDto[]> => {
    return API.get('api', '/subcategories', {})
}

export const getAllAvailableSubCategories = async (): Promise<SubCategoryDto[]> => {
    return API.get('api', '/subcategories/all', {})
}

export const getByCategory = async (categoryId: string): Promise<SubCategoryDto[]> => {
    return API.get('api', `/category/${categoryId}/subcategories`, {})
}

export const getAllSubCategories = async (categoryId: string): Promise<CategoryDto[]> => {
    return API.get('api', `/category/${categoryId}/all/subcategories`, {})
}

export const createSubCategory = async (categoryId: string, { name, color, isShared, fromAdmin, grade }: CreateSubCategoryDto): Promise<string> => {
    return API.post('api', `/category/${categoryId}/subcategories`, { body: { name, color, isShared, fromAdmin, grade } })
}

export const updateSubCategory = async (categoryId: string, subCategoryId: string, { name, color, isShared, fromAdmin, grade }: CreateSubCategoryDto): Promise<SubCategoryDto> => {
    return API.put('api', `/category/${categoryId}/subcategories/${subCategoryId}`, { body: { name, color, isShared, fromAdmin, grade } })
}

export const deleteSubCategory = async (categoryId: string, subCategoryId: string): Promise<string> => {
    return API.del('api', `/category/${categoryId}/subcategories/${subCategoryId}`, {})
}